import React, { useContext, useEffect, useState } from 'react'
import "./Newcollections.css"
// import New_collections from '../Assets/new_collections'
import Item from '../Items/Item'
import { ShopContext } from '../../Context/ShopContext';

const Newcollections = () => {
  const [New_collections, setNew_collections] = useState([]);
  const {url}=useContext(ShopContext);

  useEffect(() => {
    const fetch_data = async () => {
      try {
        await fetch(`${url}/newcollectionget`)
          .then((response) => response.json())
          .then((data) => setNew_collections(data));
      } catch (error) {
        console.log("Server is down");

      }
    }
    fetch_data();
  }, [])


  return (
    <div className='new-collections'>
      <h1>NEW COLLECTIONS</h1>
      <hr />
      <div className="collections">
        {New_collections.map((item, i) => {
          return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
        })}
      </div>
    </div>
  )
}

export default Newcollections
